import { render, staticRenderFns } from "./item_model.vue?vue&type=template&id=054e5825"
import script from "./item_model.vue?vue&type=script&lang=js"
export * from "./item_model.vue?vue&type=script&lang=js"
import style0 from "./item_model.vue?vue&type=style&index=0&id=054e5825&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports